import { render, staticRenderFns } from "./StatResources.vue?vue&type=template&id=05432e0c&scoped=true"
import script from "./StatResources.vue?vue&type=script&lang=js"
export * from "./StatResources.vue?vue&type=script&lang=js"
import style0 from "./StatResources.vue?vue&type=style&index=0&id=05432e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05432e0c",
  null
  
)

export default component.exports